import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";

function game_5011()
{

}

game_5011.odd_map  = {
  "P9":[0,0,50,80,100],
  "P8":[0,0,30,50,60],
  "P7":[0,0,25,40,50],
  "P6":[0,0,20,30,40],
  "P5":[0,0,15,20,30], //A
  "P4":[0,0,10,20,25], //K
  "P3":[0,0,10,15,20], //Q
  "P2":[0,0,5,10,15], //J
  "P1":[0,0,5,10,15], //10
};
game_5011.mul_array  = [

];

game_5011.mul = 50


game_5011.readDataValue = function(this1,data)
{
  this1.hasfree = true
  this1.isfree = common_utils.isFreeTip(data)
  this1.hasbonuswin = false
  this1.mapList = []
  var rows = 4

  var mapJson = JSON.parse(data.detail.mapData)
  this1.scatterwin = data.detail.winFreetimes

  this1.mapIndex = []
  common_utils.readDataValue(this1,data);
  let muti = 1
  let winValueList = [];
  for(var key = 0; key < mapJson.maps.length; key++)
  {
    var mapTmp = []
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < 5; i++) {
        mapTmp.push(mapJson.maps[key].map[i][j])
      }
    }
    muti = mapJson.maps[key].muti;
    this1.mapList.push(mapTmp)
    var winListDic = {}
    var mapIndexTmp = []
    for (var index = 0; index < mapJson.maps[key].winlist.length; index++)
    {
      let win_data = mapJson.maps[key].winlist[index]
      for(var subIndex = 0; subIndex < win_data.line.length; subIndex++)
      {
          var showindex = win_data.line[subIndex] * 5 + subIndex;
          mapIndexTmp.push(showindex)
      }
      slots_tool.read_win_data2(winListDic,win_data)
    }
    slots_tool.setWinValue(winValueList,winListDic,game_5011.odd_map,muti);
    this1.mapIndex.push(mapIndexTmp)
    this1.mapListDetail.push(winListDic)
  }
  this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,game_5011.mul);

  this1.$nextTick(() => {
    this1.$nextTick(() => {
      this1.$nextTick(() => {
        this1.clearLines();
        setTimeout(() => {
          this1.clearLines();
          for(var key = 0; key < mapJson.maps.length; key++)
          {
            let winlist = mapJson.maps[key].winlist;
            console.log(winlist)
            for (var index = 0; index < winlist.length; index++) {
              let win_data = winlist[index]
              for(var subIndex = 0; subIndex < win_data.line.length-1; subIndex++)
              {
                var fromIndex = win_data.line[subIndex] * 5 + subIndex;
                var toIndex = win_data.line[subIndex + 1] * 5 + subIndex + 1;
                // slots_tool.drawLines("m_s"  + key + "_" + fromindex, "m_s"  + key + "_" + toindex, index)
                slots_tool.drawLines(slots_tool.setMapsLineIdName("s",key,fromIndex), slots_tool.setMapsLineIdName("s",key,toIndex), index)
              }
            }
          }
        }, 1000);
      })
    })
  })
}
export {
  game_5011
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5011.js